// input с выбором года
// Используется в форме создания заявки CreteReqAvto.jsx
// const [years, setYears] = useState([]); // Состояние для списка годов
// <div className="flex flex-col w-1/2">
//         <YearPicker nameInput="year_from" valYearInput={formData.year_from} placeholderInput="Год от" onYearChange={handleYearChange} />
//         {errors.year_from && (
//             <p className="text-red-500 text-sm mt-1">{errors.year_from}</p>
//         )}
//  </div>
import { useState, useEffect } from 'react';
import { format } from 'date-fns';

const yearsArray = ((startYear) => {
    return Array.from({ length: 6 }, (_, i) => (startYear + i).toString());
});

const YearPicker = ({ nameInput, valYearInput, placeholderInput = "Place holder", onYearChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const now = new Date();
    const nowYear = now.getFullYear();
    const startYear = nowYear - 5; // С какого года начать
    const [selectedYear, setSelectedYear] = useState(valYearInput ? valYearInput : startYear); // Значение по умолчанию
    const [years, setYears] = useState(() => yearsArray(startYear));

    useEffect(() => {
        if (valYearInput) {
            setSelectedYear(format(new Date(valYearInput), "yyyy"));
        }
    }, [valYearInput]);

    const handleYearSelect = (year) => {
        onYearChange && onYearChange(nameInput, year);
        setSelectedYear(year);
        setIsOpen(false);
    };

    const onChangeLocal = (e) => {
        setSelectedYear(e.target.value)
    }

    return (
        <div className="relative transition-all duration-300  bg-transparent rounded-md ">
            {/* Поле ввода */}
            <input
                name={nameInput}
                type="text"
                value={selectedYear}
                onChange={onChangeLocal}
                onClick={() => setIsOpen(!isOpen)}
                className="peer ring-gray-300 dark:ring-gray-600 w-full  px-4 py-2 bg-transparent rounded-md focus:outline-none ring-1 focus:ring-green-400 transition-all duration-200 placeholder-transparent"
                placeholder=""
                readOnly
            />
            <label htmlFor={nameInput} className="absolute bg-white dark:bg-gray-800 rounded-t-lg  cursor-pointer left-0 -top-3 text-sm text-gray-500 mx-1 px-1 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-placeholder-shown:top-2 peer-focus:-top-4 peer-focus:text-green-600 peer-focus:text-sm transition-all duration-300 pointer-events-none">
                {placeholderInput}
            </label>

            {/* Выпадающий список */}
            {isOpen && (
                <div className="absolute z-10 mt-1 w-full bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-600 rounded-md shadow-lg max-h-60 overflow-y-auto">
                    <div className="grid grid-cols-2 gap-1 p-3">
                        {years.map((year) => (
                            <button
                                key={year}
                                onClick={() => handleYearSelect(year)}
                                className={`p-2 text-center rounded-md transition-all duration-200 ${year === selectedYear
                                    ? 'bg-green-500 text-white'
                                    : 'bg-gray-100 text-gray-800 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700'
                                    }`}
                            >
                                {year}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default YearPicker;